"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Login = /** @class */ (function () {
    function Login() {
        this.config = {
            htmlElements: {
                forgottenPasswordForm: null
            },
            nodeLists: {
                forgottenPasswordBtns: null
            },
            selectors: {
                forgottenPasswordBtn: '[data-forgotten-password-btn]',
                forgottenPasswordForm: '[data-forgotten-password-form]'
            }
        };
    }
    Login.prototype.init = function () {
        this.load();
        this.addEventListeners();
    };
    Login.prototype.load = function () {
        this.config.nodeLists.forgottenPasswordBtns = document.querySelectorAll(this.config.selectors.forgottenPasswordBtn);
        this.config.htmlElements.forgottenPasswordForm = document.querySelector(this.config.selectors.forgottenPasswordForm);
    };
    Login.prototype.addEventListeners = function () {
        var _this = this;
        this.config.nodeLists.forgottenPasswordBtns.forEach(function (htmlElement) { return htmlElement.addEventListener('click', _this.handleForgottenPasswordBtnClick.bind(_this)); });
    };
    Login.prototype.handleForgottenPasswordBtnClick = function () {
        this.config.htmlElements.forgottenPasswordForm.classList.toggle('hide');
    };
    return Login;
}());
exports.default = new Login();
